<div class="modal-header">
  <h4 class="modal-title">
    <i class="fa fa-edit mr-2"></i>Edit Role
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="editRoleForm" novalidate>
    <div class="form-group mb-0">

      <div class="role-name-row">
        <input type="text" class="form-control rolename-textbox" formControlName="roleName" placeholder="Role Name" />
      </div>

      <div class="row" *ngIf="editRoleForm.controls['roleName'].hasError('required') && editRoleForm.controls['roleName'].touched">
        <div class="col-md-12 text-danger">
          <i class="fa fa-exclamation-circle mr-1"></i>Please enter role name
        </div>
      </div>
      <div class="row" *ngIf="editRoleForm.controls['roleName'].hasError('pattern') && editRoleForm.controls['roleName'].touched">
        <div class="col-md-12 text-danger">
          <i class="fa fa-exclamation-circle mr-1"></i>Special Characters and Numbers are not allowed
        </div>
      </div>
      <div class="row" *ngIf="editRoleForm.controls['roleName'].hasError('maxlength')">
        <div class="col-md-12 text-danger">
          <i class="fa fa-exclamation-circle mr-1"></i>Please enter Rolename not exceeding 50 characters
        </div>
      </div>

      <div class="permissions-shell" *ngIf="menuGroups.length; else loadingMenus">
        <aside class="permissions-nav">
          <button type="button" class="permissions-nav-item"
            *ngFor="let group of menuGroups"
            [class.active]="activeMenuKey === group.key"
            (click)="setActiveMenu(group.key)">
            <span class="permissions-nav-label">{{ group.label }}</span>
            <span class="permissions-nav-count" *ngIf="getGroupSelectedCount(group) > 0">
              {{ getGroupSelectedCount(group) }}
            </span>
          </button>
        </aside>

        <section class="permissions-panel" *ngIf="activeGroup as group">
          <div class="permissions-panel-header">
            <h5 class="permissions-panel-title">{{ group.label }}</h5>
            <input type="search" class="form-control permissions-search" [(ngModel)]="permissionSearch"
              [ngModelOptions]="{standalone: true}" placeholder="Search in {{ group.label }}">
          </div>

          <div class="permissions-select-all">
            <label class="permissions-check-label">
              <input type="checkbox"
                [checked]="isSelectAllChecked(group.menuList)"
                [appIndeterminate]="isSelectAllIndeterminate(group.menuList)"
                (change)="onSelectAllChange($event, group)">
              <span>Select All</span>
            </label>
          </div>

          <div class="permissions-table-wrap">
            <table class="permissions-table">
              <thead>
                <tr>
                  <th class="col-select">Select</th>
                  <th>Permission</th>
                  <th class="col-actions">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let menu of getFilteredMenus(group)" [class.is-selected]="isMenuRowChecked(menu) || isMenuRowIndeterminate(menu)">
                  <td class="col-select">
                    <label class="permissions-check-label permissions-check-label--row">
                      <input type="checkbox"
                        [checked]="isMenuRowChecked(menu)"
                        [appIndeterminate]="isMenuRowIndeterminate(menu)"
                        (change)="onMenuRowChange($event, menu, getMenuDisplayName(menu, group), group.menuList)">
                    </label>
                  </td>
                  <td>
                    <span class="permission-name">{{ getMenuLabel(menu, group) }}</span>
                  </td>
                  <td class="col-actions">
                    <div class="permission-icons-container">
                      <button type="button" class="permission-icon-btn"
                        *ngFor="let child of getMenuActions(menu, group)"
                        [class.is-active]="isIconSelected(child.Url)"
                        [title]="child.IconName"
                        (click)="onIconClick($event, menu, getMenuDisplayName(menu, group), child, group.menuList)">
                        <i class="fa" [ngClass]="getIconClass(child.IconName)"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="getFilteredMenus(group).length === 0">
                  <td colspan="3" class="permissions-empty">No permissions match your search.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>

      <ng-template #loadingMenus>
        <div class="permissions-loading">
          <i class="fa fa-spinner fa-spin mr-2"></i>Loading permissions...
        </div>
      </ng-template>

      <div class="row mt-3" *ngIf="isfinalRoleListEmpty">
        <div class="col-md-12">
          <div class="alert alert-warning mb-0 permissions-alert">
            <i class="fa fa-exclamation-triangle mr-2"></i>
            <strong>Please select role activities from the list</strong>
          </div>
        </div>
      </div>

      <div class="added-roles-section mt-3">
        <strong class="added-roles-title">
          <i class="fa fa-check-circle mr-2"></i>Added Roles
        </strong>
        <div class="added-roles-chips" *ngIf="addedRoles.length > 0">
          <span class="added-role-chip" *ngFor="let role of addedRoles; let i = index">
            {{ getDisplayName(role.MenuDisplayName) }}
            <button type="button" class="added-role-remove" (click)="removeAddedRoleList(i, role)" aria-label="Remove">
              <i class="fa fa-times"></i>
            </button>
          </span>
        </div>
        <p class="text-muted small mb-0 mt-2" *ngIf="addedRoles.length === 0">No roles added yet</p>
      </div>

    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default btn-sm footer-button cancel-button" (click)="cancel()">
    <i class="fa fa-times mr-2"></i>Cancel
  </button>
  <button type="button" class="btn btn-primary btn-sm footer-button"
    [disabled]="(!editRoleForm.valid) || isfinalRoleListEmpty" (click)="UpdateRole()">
    <i class="fa fa-save mr-2"></i>Update
  </button>
</div>
